export default "__VITE_ASSET__4HZhqF8g__"